import script from "./ContactDetailList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactDetailList.vue?vue&type=script&setup=true&lang=js"

import "./ContactDetailList.vue?vue&type=style&index=0&id=0d9b6458&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9b6458"]])

export default __exports__